import { useAuthentication } from '@proton/components';

import usePublicSession from '../_api/usePublicSession';

export const usePublicSessionUser = () => {
    const auth = useAuthentication();
    const { user, userAddressEmail } = usePublicSession();
    const localID: number | undefined = auth.getLocalID();
    const UID: string = auth.getUID();

    return { user, userAddressEmail, localID, UID };
};
